var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2H11.25V3.03971C7.73668 3.41394 5 6.38738 5 10C5 10.8918 5.16678 11.7447 5.47085 12.5291L3 15V16.5V18H4.5H8.53544C8.77806 19.6961 10.2368 21 12 21C13.7632 21 15.2219 19.6961 15.4646 18H19.5H21V16.5V15L18.5291 12.5291C18.8332 11.7447 19 10.8918 19 10C19 6.38738 16.2633 3.41394 12.75 3.03971V2ZM16.7772 12.8985L17.1305 11.987C17.3687 11.3727 17.5 10.7035 17.5 10C17.5 6.96243 15.0376 4.5 12 4.5C8.96243 4.5 6.5 6.96243 6.5 10C6.5 10.7035 6.63133 11.3727 6.86945 11.987L7.22279 12.8985L6.53151 13.5898L4.5 15.6213V16.5H19.5V15.6213L17.4685 13.5898L16.7772 12.8985ZM12 19.5C11.0681 19.5 10.285 18.8626 10.063 18H13.937C13.715 18.8626 12.9319 19.5 12 19.5Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b87d8d78.svg";
export { ForwardRef as ReactComponent };